import classNames from "classnames";
import * as React from "react";
import { Input, Label } from "uxp/components";
import { hasValue } from "../../../../util";
import { IBaseFieldProperty, IBaseInputFieldProperty, IPropertyEditorProps, IUIFieldProps, registerUIField } from "../../common";
import { FieldProperty, FieldTitle, IFieldTitleProps } from "../../components/FieldTitle";
import { CustomColorPicker, escapeUnit, Property, PropertyContainer, PropertyGroup, PropertyGroupTitle, PropertyTitle, TextAlignEditor } from "../../ui-props/common";
interface IGPSFieldProperty extends IBaseInputFieldProperty {
	placeholder: string,
	fieldLabel: IFieldTitleProps,
}

export const Field: React.FunctionComponent<IUIFieldProps<IGPSFieldProperty>> = (props) => {

	let { placeholder, onChange, value } = props.fieldProps || {}
	let [error, setError] = React.useState(null);
	let [loading, setLoading] = React.useState(false);

	const hasValueSetRef = React.useRef<boolean>(false)

	React.useEffect(() => {
		if (!hasValueSetRef.current && (!props.mode || props.mode =='live')) {
			if (navigator.geolocation) {
				setLoading(true);
				navigator.geolocation.getCurrentPosition((pos) => {
					setLoading(false);
					let { latitude, longitude } = pos.coords;
					let newValue = { latitude, longitude };
					setError(null);
					hasValueSetRef.current = true
					onChange(newValue);

				}, (err) => {
					console.log('ERROR READING GPS', err);
					setError(err);
					hasValueSetRef.current = false
					onChange(null);
					setLoading(false);
				});
			}
		}
	}, [props])

	return (
		<div className={classNames('ui-field', props.mode)} >
			<FieldTitle {...props?.fieldProps?.fieldLabel || {}} />
			<Input
				value={loading ? 'Loading...' :
					value ? `${value.latitude} , ${value.longitude}` :
						error ? 'Error reading location' : ''
				}
				placeholder={placeholder || ''}
				readOnly={true}
				onChange={() => { }}
			/>
		</div >
	)
}


export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<IGPSFieldProperty>> = (props) => {
	return <PropertyContainer>
		<PropertyGroup>
			<PropertyGroupTitle>GPS Field</PropertyGroupTitle>

			<Property>
				<PropertyTitle>Placeholder</PropertyTitle>
				<Input
					value={props.uiProps.placeholder || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { placeholder: s }))}
				/>
			</Property>
			<FieldProperty uiProps={props.uiProps} onChange={props.onChange} />

		</PropertyGroup>

	</PropertyContainer>;
}
registerUIField({
	id: 'gps',
	category: 'inputs',
	description: 'Current GPS Coordinates',
	field: Field,
	isInputField: true,
	propertyEditor: PropertyEditor,
	defaultProps: {
		value: null,
		placeholder: 'Location',
		fieldLabel: {
			label: 'Current Position',
		},
	},
	type:'position'

});


